import { css } from 'twin.macro';
import { Fragment } from 'react';
import { Card } from 'react-bootstrap';
import FormElement from './FormElement';

const StaticPreview = ({
    formElements,
    elementRef,
    isPreview,
    errors,
    isDraft = false,
    setError,
    clearErrors,
    setValue,
}) => {
    return (
        <Fragment>
            {formElements &&
                Array.isArray(formElements) &&
                formElements.length > 0 &&
                formElements.map((form) => (
                    <div
                        key={form._id}
                        className={`form-element `}
                        css={css`
                            padding: 1rem 0.5rem 1rem 1rem;
                            overflow-wrap: break-word;
                            min-height: 125px;
                            min-height: 100px;
                            height: fit-content;
                            border-radius: 0.25rem;
                            // border: 1px solid #dddddd90;
                            // margin-bottom: 3rem;
                            margin-bottom: 1.5rem;
                            margin-left: 6px;
                        `}
                    >
                        <FormElement
                            form={{ ...(form || {}), required: isDraft ? false : form?.required }}
                            elementRef={elementRef}
                            isPreview={isPreview}
                            isDraft={isDraft}
                            errors={errors}
                            setError={setError}
                            clearErrors={clearErrors}
                            setValue={setValue}
                        />
                    </div>
                ))}
        </Fragment>
    );
};

export default StaticPreview;
